import { render, staticRenderFns } from "./TopQuotesWidget.vue?vue&type=template&id=159a300e&scoped=true"
import script from "./TopQuotesWidget.vue?vue&type=script&lang=ts"
export * from "./TopQuotesWidget.vue?vue&type=script&lang=ts"
import style0 from "./TopQuotesWidget.vue?vue&type=style&index=0&id=159a300e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159a300e",
  null
  
)

export default component.exports